import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m32.658 18.022-7.723-13.6L27.418.128a.258.258 0 0 1 .447 0l10.329 17.893zM13.259 4.421l-7.723 13.6H0L10.328.13a.258.258 0 0 1 .447 0zM11.352 10.398l2.688-4.734 4.328 7.496-2.722 4.715zM26.86 10.429l-2.69-4.735-7.86 13.618L19.065 24z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "moken-logo"}) } }